<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline :title="title">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Theme Name
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="name"
                placeholder="Enter Theme Name"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox
                label="is Recess *"
                v-model="isChecked"
                :checked="isChecked"
              >
              </v-checkbox>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2"> Skill Name </label>
              <div v-for="(n, i) of skill" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" md="10">
                          <v-text-field
                            class="my-0 py-1"
                            counter="100"
                            placeholder="Enter Skill Name"
                            :required="i === 0"
                            v-model.trim="skill[i].name"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center"
                    >
                      <label class="font-weight-medium body-2"
                        >No. {{ i + 1 }}</label
                      >

                      <v-card-actions>
                        <v-btn
                          title="Delete skill"
                          elevation="1"
                          color="error"
                          @click="deleteRow(i, skill[i])"
                        >
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  bottom
                  right
                  elevation="1"
                  color="primary"
                  @click="
                    skill.push({
                      name: ''
                    })
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Skill
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import _ from 'lodash'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['themeAndSkillId'],
  data () {
    return {
      name: '',
      classList: [],
      skill: [
        {
          name: ''
        }
      ],
      isEdit: false,
      deleteSkill: [],
      title: 'Add Theme and Skills',
      isChecked: false,
      isRecess: ''
    }
  },
  created: async function () {
    this.title = this.themeAndSkillId
      ? 'Edit Theme and Skills'
      : 'Add Theme and Skills'
    if (this.themeAndSkillId) {
      this.isEdit = true
      await this.getThemeAndSkillById()
    }
  },
  watch: {},
  methods: {
    save: async function () {
      try {
        for (let item of this.skill) {
          if (item.name === '') {
            return this.errMsg('Skill name is required!')
          }
        }
        let formData = {
          name: this.name,
          skills: this.skill,
          isRecess: this.isChecked
        }
        if (this.isEdit) {
          delete this.skill.curriculumThemeID
        }

        if (this.isEdit) {
          let res = await http.put(
            `${CONSTANTS.API_URL}/api/curriculum_cms/update-theme/${this.themeAndSkillId}`,
            formData
          )
          this.okMsg(res.data)
        } else {
          let res = await http.post(
            `${CONSTANTS.API_URL}/api/curriculum_cms/create-theme`,
            formData
          )
          this.okMsg(res.data)
        }

        this.$router.push({ name: 'themeAndSkillsList' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getThemeAndSkillById: async function () {
      try {
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-themes/${this.themeAndSkillId}`
        )
        res = res.data

        this.name = res.name
        this.skill = res.Skills
        this.isChecked = res.isRecess
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },

    deleteRow (e, item) {
      if (item.id) {
        this.deleteSkill.push(item.id)
      }
      if (this.skill.length > 1) {
        this.skill = _.filter(this.skill, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one skill is required!')
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
